// extracted by mini-css-extract-plugin
export default {"brandMark":"pKk839niOGtsUNShbWzb"};